import React from 'react';

interface Props {
  className?: string;
}

const Oil: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 19"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3438 2.70544C17.9479 1.2228 16.4236 0.344326 14.941 0.740159L13.3333 1.17071L14.4722 5.42071L10.7118 6.39294L10.4931 5.76446L10.2326 5.02141H8.65625L8.39583 5.76446L7.92361 7.11863L3.33333 8.30613V6.96585V6.13252H1.66667V6.96585V16.1325H1.11111H0V18.3547H1.11111H18.8889H20V16.1325H18.8889H14.1215L11.8056 9.51794L9.64583 10.077L10.6007 12.7992H8.28819L9.20139 10.195L6.61111 10.8652L4.76736 16.1325H3.33333V10.6047L15.0486 7.56655L16.2118 11.9034L17.8229 11.4728C19.3056 11.077 20.184 9.55266 19.7882 8.07002L18.3438 2.70544ZM7.12153 16.1325L7.51042 15.0214H11.3785L11.7674 16.1325H7.12153ZM9.45486 2.79919L9.44444 2.76794L9.43403 2.79919H9.45486Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Oil;
